import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// models
import { TreeNode } from '../../models/interfaces/tree-node.interface';
//factory
import { createChild, createParent } from '../../factory/tree-node-factory';
// Services
import { TreeService } from './tree.service';
import { ClassRoomsService } from '../classroom.service';
import { ClassroomFilterDto } from '../../models/dto/classroom-filter.dto';

@Injectable()
export class TreeSegmentsService extends TreeService {
  constructor(
    private readonly classroomsServive: ClassRoomsService,
    ) {
    super();
  }

  createTree(
    idsClassRooms: string[] | undefined,
    classroomFilter: ClassroomFilterDto = {},
    isCheckable: boolean = true
  ): Observable<TreeNode> {
    return new Observable((subscriber) => {
      this.classroomsServive.getTree(classroomFilter).subscribe((segments) => {
        if (segments && segments.length > 0) {
          let segmentsTree = createParent(
            'allSegments',
            'Todos os segmentos',
            isCheckable
          );
          segmentsTree.children = [];

          let seriesTree = createParent('allSeries', 'Series', isCheckable);
          seriesTree.children = [];

          let classRoomsTree = createParent('allClassRooms', 'Turmas');
          classRoomsTree.children = [];

          segments.forEach((seg) => {
            const segNode = createChild(
              segmentsTree,
              undefined,
              seg.id ?? '',
              seg.name,
              isCheckable
            );
            segNode.children = [];

            seg.series.forEach((serie) => {
              const serieNode = createChild(
                segNode,
                undefined,
                '',
                serie.name,
                isCheckable
              );
              serieNode.children = [];
              seriesTree.children?.push(serieNode);

              serie.classRooms.forEach((classRoom) => {
                const classRoomNode = createChild(
                  serieNode,
                  idsClassRooms,
                  classRoom.id ?? '',
                  classRoom.name
                );
                classRoomsTree.children?.push(classRoomNode);

                serieNode.children?.push(classRoomNode);
              });

              segNode.children?.push(serieNode);
            });

            segmentsTree.children?.push(segNode);
          });

          subscriber.next(segmentsTree);
        }
      });
    });
  }

  createTreeNoRoot(
    idsClassRooms: string[] | undefined,
    isCheckable: boolean = true,
    classroomFilter: ClassroomFilterDto
  ): Observable<TreeNode> {
    return new Observable((subscriber) => {
      this.classroomsServive.getTree(classroomFilter).subscribe((segments) => {
        if (segments && segments.length > 0) {
          let segmentsTree = createParent(
            'allSegments',
            undefined,
            isCheckable
          );
          segmentsTree.showChildren = true;
          segmentsTree.children = [];

          let seriesTree = createParent('allSeries', 'Series', isCheckable);
          seriesTree.children = [];

          let classRoomsTree = createParent('allClassRooms', 'Turmas');
          classRoomsTree.children = [];

          segments.forEach((seg) => {
            const segNode = createParent(seg.id, seg.name, isCheckable);
            segNode.children = [];

            seg.series.forEach((serie) => {
              const serieNode = createChild(
                segNode,
                undefined,
                '',
                serie.name,
                isCheckable
              );
              serieNode.children = [];
              seriesTree.children?.push(serieNode);

              serie.classRooms.forEach((classRoom) => {
                const classRoomNode = createChild(
                  serieNode,
                  idsClassRooms,
                  classRoom.id ?? '',
                  classRoom.name
                );
                classRoomsTree.children?.push(classRoomNode);

                serieNode.children?.push(classRoomNode);
              });

              segNode.children?.push(serieNode);
            });

            segmentsTree.children?.push(segNode);
          });

          subscriber.next(segmentsTree);
        }
      });
    });
  }

  updateSelectedClassRooms(
    segmentTree: TreeNode,
    idsClassRooms: string[] | undefined
  ) {
    segmentTree.children?.forEach((segmentNode) => {
      segmentNode.children?.forEach((classroomTree) => {
        classroomTree.children?.forEach((classroomNode) => {
          const hasItem = idsClassRooms?.includes(classroomNode.id) ?? false;
          if (classroomNode.isChecked) {
            if (!hasItem && !classroomNode.isParent) {
              idsClassRooms?.push(classroomNode.id);
            }
          } else {
            if (hasItem && !classroomNode.isParent) {
              const itemIndex =
                idsClassRooms?.indexOf(classroomNode.id, 0) ?? 0;
              if (itemIndex > -1) idsClassRooms?.splice(itemIndex, 1);
            }
          }
        });
      });
    });
    return idsClassRooms;
  }

  hasCheckedItems(treeNode: TreeNode): boolean {
    let countCheckeds = 0
    treeNode.children!.forEach( segment => {
      segment.children!.forEach( serie => {
        serie.children!.forEach( classRomm => {
          if(classRomm.isChecked)
            countCheckeds += 1
        } )
      } )
    } )
    if (countCheckeds)
      return countCheckeds > 0
    else
      return false
  }

  private getCheckeds(treeNode: TreeNode): TreeNode[] | undefined {
    const checkeds = treeNode.children?.
    filter( seg => seg.children?.
      filter(serie => serie.children?.
        filter(classroom => classroom.isChecked)
      )
    )
    return checkeds
  }

  formatSelectedsText(treeNode: TreeNode): string {
    let countCheckeds: number = 0
    const checkeds = this.getCheckeds(treeNode)
    if(checkeds) {
      checkeds.forEach( segment => {
        segment.children!.forEach( serie => {
          serie.children!.forEach( classRomm => {
            if(classRomm.isChecked)
              countCheckeds += 1
          } )
        } )
      } )
    }
    let concatNames: string = ''

    if (countCheckeds && countCheckeds > 0) {
      if (checkeds) {
        checkeds.forEach( segment => {
          segment.children!.forEach( serie => {
            serie.children!.forEach( classRomm => {
              if(classRomm.isChecked){
                let firstClassRomm = true
                if(firstClassRomm){
                  if(!classRomm.name?.toLowerCase().includes(serie.name!.toLowerCase()))
                    concatNames += serie.name + ' - '
                  firstClassRomm = false
                }
                concatNames += classRomm.name + ', '
              }
            } )
          } )
        } )
      }
    }

    if (countCheckeds && concatNames.length > 0) {
      if (concatNames.length > 20) {
        let nameToShow = ''
        let countNameToShow = 0
        const splitNames = concatNames.split(',')

        while(nameToShow.length<20){
          nameToShow += splitNames[countNameToShow] + ', '
          countNameToShow += 1
        }
        nameToShow = nameToShow.replace(/,\s*$/, ' ')
        const numClassToShow: number = splitNames.length - countNameToShow -1

        if (countCheckeds - numClassToShow > 0)
          return nameToShow + ` + ${numClassToShow}`
        else
          return nameToShow
      } else {
        //replace last comma
        return concatNames.replace(/,\s*$/, '')
      }
    } else
      return concatNames.replace(/,\s*$/, '')
  }
}
